import { createMiddleware } from "@tanstack/react-start";

/**
 * Equivalent of the generated `attachSupabaseAuth`, but the Supabase client is
 * imported lazily so the auth/storage/realtime bundles stay out of the initial
 * marketing-page JS payload.
 *
 * This middleware runs only in the browser. During server rendering, the
 * loaders call server functions directly, and this middleware also runs
 * there. On the server the auth client has no storage, so it never has a
 * session and never adds a token. It did add a fault: the auth client is one
 * object for the whole Worker isolate, and each call waits on a promise that
 * the first request made. Cloudflare does not reliably continue a promise
 * across requests. On 30 Sep 2026, 16 of 72 uncached blog post requests hung
 * with no response and less than 10 ms CPU, and no Supabase read timed out.
 */
export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    if (typeof window === "undefined") return next();
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);
